export default __webpack_public_path__ + "static/media/check-icon.a34cc644.svg";